import * as React from "react"

import { USER_ROLE, VISIBILITY_TRACKER_ROUTES } from "@constants"
import AppLayout from "Layout"
import PipelinePage from "./index"


export const VtPipelineRoutes = {
	path: VISIBILITY_TRACKER_ROUTES.PIPELINE_PATH,
	title: VISIBILITY_TRACKER_ROUTES.PIPELINE_TITLE,
	icon: 'diagram-project',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'Operational view of every VT task across the pipeline stages',
	access: USER_ROLE.ADMIN,
	children: [{
		element: <PipelinePage />,
		index: true
	}]
}
